var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.083 5.335V3.333c0-1.19-.642-2.291-1.684-2.887a3.4 3.4 0 0 0-3.37 0 3.33 3.33 0 0 0-1.683 2.887v2.002C.602 5.335 0 5.93 0 6.665v3.999c-.002.354.14.694.392.944.253.251.596.392.954.392h6.737c.743 0 1.346-.596 1.346-1.33V6.664c0-.353-.142-.691-.394-.94a1.35 1.35 0 0 0-.952-.39m-5.392-.666V3.333a2 2 0 0 1 1.04-1.646 2.04 2.04 0 0 1 1.962 0 2 2 0 0 1 1.04 1.646v2.002H2.69z"
  })));
};
export default SvgLock;